// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2oZd_","image":"Header_image__3Dio2","name":"Header_name__bkX1Q","info":"Header_info__3im0c","infoRow":"Header_infoRow__3y6VU"};